// extracted by mini-css-extract-plugin
export default {"subContent":"OverviewItem_subContent__kPq3M","addRowBtn":"OverviewItem_addRowBtn__GOiTV","required":"OverviewItem_required__OPXr4"};